module.exports = __webpack_public_path__ + "static/media/telemed_icon_active.f74698fd.svg";